<script lang="ts">
import { defineComponent, onMounted, PropType } from 'vue';

import { Clickstream } from './clickstream-script';
import { ClickstreamProps } from './interfaces';

function useClickstream(props: ClickstreamProps) {
    new Clickstream(props.identityPoolId, props.bindArg);

    return {
        onMounted
    };
}

export default defineComponent({
    name: 'click-stream',
    props: {
        identityPoolId: {
            type: String as PropType<string>,
            default: "ap-southeast-2:a3c6c3fc-9f51-44b6-a1b2-5d0dc86dcd9d"
        },
        bindArg: {
            type: String as PropType<string>,
            default: "a, button, img, label, input[type=text], input[type=checkbox], input[type=radio], input[type=submit], item, li, i"
        }
    },
    setup(props: ClickstreamProps) {
        const { ...methods } = useClickstream(props);

        return {
            ...methods
        };
    }
});
</script>
<style lang="postcss">
</style>
